
import AgencyAssetsBase from "../../BaseModels/AgencyAssets";
const Base_Url = 'AgencyAssets'
class AgencyAssetsModel extends AgencyAssetsBase {

}
export default AgencyAssetsModel